module.exports = __webpack_public_path__ + "img/img13.24b5c8d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/08/img13.jpg
// module id = 309
// module chunks = 0